import React, { memo, useEffect } from 'react';

import SvgSprite from '@/components/atomic/atoms/data-display/icons/icon-sprite/styled';
import type { IconSpriteProps } from '@/components/atomic/atoms/data-display/icons/icon-sprite/typings';
import withExposer from '@/hocs/with-exposer';
import useIsIconValid from '@/hooks/use-is-icon-valid';
import useStore from '@/state';
import addIconAction from '@/state/selectors/icons/add-icon';
import type { BasicComponentProps } from '@/typings/generic';

const IconSpriteComponent: React.FC<IconSpriteProps & BasicComponentProps> = ({
	icon,
	$width = 20,
	$height = 20,
	...props
}) => {
	const addIcon = useStore(addIconAction);
	const isIconValid = useIsIconValid(icon);
	useEffect(() => {
		if (icon && isIconValid) addIcon(icon);
	}, [addIcon, icon, isIconValid]);

	if (!isIconValid) return null;

	return (
		<SvgSprite $width={$width} $height={$height} {...props}>
			<use xlinkHref={`#${icon}`} />
		</SvgSprite>
	);
};

const IconSprite = memo(withExposer(IconSpriteComponent, 'iconSprite'));

export default IconSprite;
